import { Box, Typography } from "@mui/material";
import BackButton from "../BackButton";

const PageHeader = ({ title, description, backText, onBack, sx }) => {
  const containerStyle = {
    mb: "2rem",
    ...sx,
  };
  const descStyle = {
    mt: "0.75rem",
    lineHeight: 1.5,
  };

  return (
    <Box sx={containerStyle}>
      {backText && <BackButton text={backText} goBack={onBack} />}
      <Typography variant="h1">{title}</Typography>
      {description && (
        <Typography sx={descStyle} variant="body2">
          {description}
        </Typography>
      )}
    </Box>
  );
};

export default PageHeader;
